/** Parse a free-text weeks field into a set of teaching-week numbers; null = every week. */
export function parseWeeks(w?: string | null, total = 15): Set<number> | null {
  if (!w) return null;
  const s = w.toLowerCase();
  if (/^\s*(every|svake?|sve)\b/.test(s)) return null;
  if (/\b(odd|neparn)/.test(s)) return new Set(range(1, total).filter((n) => n % 2 === 1));
  if (/\b(even|parn)/.test(s)) return new Set(range(1, total).filter((n) => n % 2 === 0));
  const body = s.replace(/\(.*?\)/g, " ").replace(/wk\s*1\s*=.*$/, " ");
  const out = new Set<number>();
  for (const m of body.matchAll(/(\d{1,2})\s*[-–]\s*(\d{1,2})|(\d{1,2})/g)) {
    if (m[1]) range(+m[1], +m[2]).forEach((n) => out.add(n));
    else out.add(+m[3]);
  }
  const valid = [...out].filter((n) => n >= 1 && n <= 30);
  return valid.length ? new Set(valid) : null;
}

export function weeksOverlap(a?: string | null, b?: string | null): boolean {
  const A = parseWeeks(a), B = parseWeeks(b);
  if (!A || !B) return true;
  for (const n of A) if (B.has(n)) return true;
  return false;
}

const range = (a: number, b: number) => Array.from({ length: Math.max(0, b - a + 1) }, (_, i) => a + i);
